import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { useDesignContext } from '@klarna/designtokens';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import View from '@bubble-ui/primitive-view';
import Rect from '@bubble-ui/primitive-rect';
import Surface from '@bubble-ui/primitive-surface';
import Text from '@bubble-ui/primitive-text';
import { isNative } from '@bubble-ui/util-platform';
import useDeprecationWarning from '@bubble-ui/hook-use-deprecation-warning';
import { defaultDesignTokens } from './defaultDesignTokens';
import { getDefaultStyleSheet } from './getDefaultStyleSheet';
import { getIds } from './getIds';
var Timeline = _ref => {
  var {
    entries,
    isContinuous,
    id,
    small,
    testID,
    titlesTag = 'h2'
  } = _ref;
  useDeprecationWarning({
    componentName: 'Timeline',
    removalDate: 'v6.0.0',
    useInstead: 'Stepper'
  });
  var designContext = useDesignContext(defaultDesignTokens);
  var ids = getIds(id);
  var {
    rootStyle,
    gutterContainerStyle,
    firstGutterStyle,
    gutterStyle,
    lastGutterStyle,
    continousGutterContainerStyle,
    continousGutterStyle,
    continousGutterTrailStyle,
    entryContainerStyle,
    entryBulletContainerStyle,
    entryContentContainerStyle,
    entryTitleContainerStyle,
    entryTitleTextStyle,
    entryDescriptionContainerStyle,
    entryCustomContentContainerStyle,
    paragraphTertiaryCorrectFootprintLightStyle,
    bulletStyle
  } = getDefaultStyleSheet({
    designContext,
    small
  });
  return /*#__PURE__*/React.createElement(View, {
    id: ids.root,
    testID: testID,
    style: rootStyle,
    role: "list"
  }, entries.map((entry, index) => /*#__PURE__*/React.createElement(View, {
    id: ids.entry(index),
    key: index,
    style: entryContainerStyle,
    role: "listitem"
  }, /*#__PURE__*/React.createElement(View, {
    style: gutterContainerStyle
  }, entries.length === 1 ? null : index === 0 ? /*#__PURE__*/React.createElement(View, {
    style: firstGutterStyle
  }) : index < entries.length - 1 ? /*#__PURE__*/React.createElement(View, {
    style: gutterStyle
  }) : isContinuous ? /*#__PURE__*/React.createElement(View, {
    style: continousGutterContainerStyle
  }, /*#__PURE__*/React.createElement(View, {
    style: continousGutterStyle
  }), /*#__PURE__*/React.createElement(View, {
    style: continousGutterTrailStyle
  }), /*#__PURE__*/React.createElement(View, {
    style: continousGutterTrailStyle
  })) : /*#__PURE__*/React.createElement(View, {
    style: lastGutterStyle
  }), /*#__PURE__*/React.createElement(View, {
    style: entryBulletContainerStyle
  }, /*#__PURE__*/React.createElement(Surface, {
    width: bulletStyle.width,
    height: bulletStyle.height
  }, /*#__PURE__*/React.createElement(Rect, bulletStyle)))), /*#__PURE__*/React.createElement(View, {
    style: entryContentContainerStyle
  }, /*#__PURE__*/React.createElement(View, {
    style: entryTitleContainerStyle
  }, /*#__PURE__*/React.createElement(Text, {
    tag: titlesTag,
    style: entryTitleTextStyle
  }, entry.title)), /*#__PURE__*/React.createElement(View, {
    style: entryDescriptionContainerStyle
  }, /*#__PURE__*/React.createElement(Text, _extends({}, isNative ? {
    numberOfLines: 0
  } : {}, {
    tag: "paragraph",
    style: paragraphTertiaryCorrectFootprintLightStyle
  }), entry.description)), entry.customContent && /*#__PURE__*/React.createElement(View, {
    style: entryCustomContentContainerStyle
  }, entry.customContent)))));
};
Timeline.displayName = 'Timeline';

/**
 * @deprecated this component is outdated and will be removed with v6.0.0. Use Stepper instead.
 */
export default withProvisionalOverrideFromContext(Timeline);
//# sourceMappingURL=index.js.map